package com.dotdrives.model

data class SessionInfo(
    val userId: String,
    val email: String,
)

enum class AuthProvider {
    Google,
    Microsoft,
}

enum class AuthAudience {
    Team,
    Giver,
}

enum class AuthFormState {
    SignIn,
    SignUp,
    ForgotPassword,
    MagicLinkSent,
    PasswordResetSent,
    ConfirmationSent,
}

enum class AuthSessionSource {
    Recovery,
    External,
    Other,
}

data class AuthSessionSnapshot(
    val session: SessionInfo?,
    val source: AuthSessionSource,
)

sealed interface SignUpOutcome {
    data class SignedIn(val session: SessionInfo) : SignUpOutcome

    data object ConfirmationRequired : SignUpOutcome
}
